import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import { APIURL, TZ } from '../../../Global';
import { sampleList } from './sampleList';
import { useAlert } from 'react-alert';
import CustomSelect from '../AddMedicines/CustomSelect';
import { optionsList } from '../AddMedicines/formOptions';
import { IoCopyOutline } from "react-icons/io5";
import TestParameterRow from './TestParameterRow';
const TestShow = (props) => {
    const [testData, setTestData] = useState({
        sample: props.type === 'testgroup' ? '' : 'blood',
        name: '',
        unit: '',
        note: '',
        input_type: '',
    });
    const [refRange, setRefRange] = useState([
        {
            category: '',
            min_value: '',
            max_value: '',
        },
    ]);
    const [panels, setPanels] = useState([]);
    const [panelsList, setPanelsList] = useState([]);
    const [tests, setTests] = useState([]);
    const [error, setError] = useState({ sample: '', panels: '', tests: '', testName: '' });
    const alert = useAlert();
    const [sampleType, setSampleType] = useState(null)
    const samples = sampleList.map((item) => ({ value: item, label: item }));

    const specificTestOptions = [
        { value: 'Eosinophils', label: 'Eosinophils' },
        { value: 'Lymphocytes', label: 'Lymphocytes' },
        { value: 'Neutrophils', label: 'Neutrophils' },
        { value: 'Monocytes', label: 'Monocytes' },
        { value: 'MPV', label: 'MPV' },
    ];

    const valueOptions = [
        { value: 'boolean', label: 'Boolean' },
        { value: 'text', label: 'Character' },
        { value: 'numeric', label: 'Numeric' },
    ];

    useEffect(() => {
        if ((testData.sample !== '' && props.type === 'global') || (props.type === 'testgroup' && props.testGroup.value)) {
            const tokenString = sessionStorage.getItem('usertoken');
            const str = tokenString.replace(/["]+/g, '');
            const formattedSample = testData.sample.replace(/\s+/g, '_');
            const endPoint = props.type === 'global' ? `lab-test/?sample=${formattedSample}&${TZ}` : `master-test-group/?${TZ}`
            axios
                .get(`${APIURL}/api/v1/staff/${endPoint}`, {
                    headers: {
                        Authorization: 'Token ' + str,
                    },
                })
                .then((res) => {
                    if (res.status === 200 && res.data.status === 'success') {
                        const panelsOptions = res.data.panels.map((panel) => ({
                            value: panel.id,
                            label: panel.panel_name,
                        }));
                        setPanelsList(panelsOptions);
                    } else {
                        alert.error(res.data.message || 'Error fetching tests.');
                    }
                })
                .catch((err) => {
                    alert.error('Error fetching sample data.');
                });
        }
    }, [testData.sample, props]);
    const addTestRow = () => {
        let nextOrder = tests.length > 0 ? Math.max(...tests.map(t => parseInt(t.order) || 0)) + 1 : 1;
        setTests([...tests, {
            selectedOption: null, unit: '', note: '', order: nextOrder.toString(),
            value: '', reference_parameter: [{ category: '', min_value: '', max_value: '' }], sub_tests: []
        }]);
    };

    const handleCategoryClick = (category) => {
        setTestData((current) => ({
            ...current,
            sample: category,
        }));
    };
    const handleAddSubTest = (parentIndex) => {
        const updatedTests = [...tests];
        if (!updatedTests[parentIndex].sub_tests) updatedTests[parentIndex].sub_tests = [];
        const subTests = updatedTests[parentIndex].sub_tests;
        let nextOrder = subTests.length > 0
            ? Math.max(...subTests.map(t => parseInt(t.order) || 0)) + 1
            : 1;
        updatedTests[parentIndex].sub_tests.push({
            selectedOption: null, unit: '', note: '', order: nextOrder.toString(), value: '',
            reference_parameter: [{ category: '', min_value: '', max_value: '' }]
        });
        setTests(updatedTests);
    };
    const handleTestFieldChange = (index, field, value, subIndex = null) => {
        const updatedTests = [...tests];
        if (subIndex !== null) {
            updatedTests[index].sub_tests[subIndex] = { ...updatedTests[index].sub_tests[subIndex], [field]: value };
        } else {
            updatedTests[index] = { ...updatedTests[index], [field]: value };
        }
        setTests(updatedTests);
    };
    const removeTestRow = (index, subIndex = null) => {
        const updatedTests = [...tests];
        if (subIndex !== null) {
            updatedTests[index].sub_tests = updatedTests[index].sub_tests.filter((_, i) => i !== subIndex);
        } else {
            updatedTests.splice(index, 1);
        }
        setTests(updatedTests);
    };
    const handleNestedRefChange = (testIndex, refIndex, field, value, subIndex = null) => {
        const updatedTests = [...tests];
        const target = subIndex !== null ? updatedTests[testIndex].sub_tests[subIndex] : updatedTests[testIndex];
        target.reference_parameter[refIndex][field] = value;
        setTests(updatedTests);
    };
    const addNestedRefRange = (testIndex, subIndex = null) => {
        const updatedTests = [...tests];
        const target = subIndex !== null ? updatedTests[testIndex].sub_tests[subIndex] : updatedTests[testIndex];
        target.reference_parameter.push({ category: '', min_value: '', max_value: '' });
        setTests(updatedTests);
    };
    const removeNestedRefRange = (testIndex, refIndex, subIndex = null) => {
        const updatedTests = [...tests];
        const target = subIndex !== null ? updatedTests[testIndex].sub_tests[subIndex] : updatedTests[testIndex];
        if (target.reference_parameter.length > 1) {
            target.reference_parameter = target.reference_parameter.filter((_, i) => i !== refIndex);
            setTests(updatedTests);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTestData((current) => ({
            ...current,
            [name]: value,
        }));
        setError((currentState) => ({
            ...currentState,
            testName: '',
        }));
    };

    const handleRefRangeChange = (index, e) => {
        const { name, value } = e.target;
        const updatedRefRange = [...refRange];
        updatedRefRange[index][name] = value;
        setRefRange(updatedRefRange);
    };

    const handleRefChange = (index, selectedOption) => {
        const updatedRefRange = [...refRange];
        updatedRefRange[index].category = selectedOption.value;
        setRefRange(updatedRefRange);
    };


    const addRefRange = () => {
        setRefRange([
            ...refRange,
            {
                category: '',
                min_value: '',
                max_value: '',
            },
        ]);
    };

    const removeRefRange = (index) => {
        const updatedRefRange = refRange.filter((_, i) => i !== index);
        setRefRange(updatedRefRange);
    };

    const handleTestChange = (selectedOptions) => {
        setError((currentState) => ({
            ...currentState,
            tests: '',
        }));

        if (!selectedOptions) {
            setPanels([]);
            return;
        }

        setPanels(selectedOptions);
    };

    const handleSubmit = () => {
        if ((!testData.sample && props.type === 'global') || testData.name === "") {
            if (!testData.sample && props.type === 'global') {
                setError((currentState) => ({ ...currentState, sample: 'Sample is required.' }));
            }
            if (!testData.name || testData.name === "") {
                setError((currentState) => ({ ...currentState, testName: 'Test Name is required.' }));
            }
            return;
        }
        const hasOrderErrors = (items) => {
        const orders = items.map(i => i.order?.toString());
        const hasDuplicate = orders.some((val, i) => val !== "" && orders.indexOf(val) !== i);
        const hasExceeded = items.some(i => parseInt(i.order) > 10);
        return hasDuplicate || hasExceeded;
    };

    // Check main parameters
    if (hasOrderErrors(tests)) {
        alert.error("Please fix duplicate or invalid order numbers in parameters.");
        return;
    }

    // Check subparameters within each test
    const subParameterError = tests.some(test => 
        test.sub_tests && hasOrderErrors(test.sub_tests)
    );

    if (subParameterError) {
        alert.error("Please fix duplicate or invalid order numbers in subparameters.");
        return;
    }
        const invalidRanges = refRange.some(range => {
            const hasSomeFields = range.category || range.min_value || range.max_value;
            const hasAllFields = range.category && range.min_value && range.max_value;

            return hasSomeFields && !hasAllFields;
        });

        if (invalidRanges) {
            alert.error('Please complete all fields for each reference range (category, min, and max values)');
            return;
        }

        const payload = {
            test_name: testData.name,
            ...(props.type === 'global'
                ? { sample: testData.sample }
                : sampleType && { sample: sampleType.value }
            ),
            ...(props.type === 'testgroup'
                && {
                is_general: true,
                test_group: props.testGroup.value
            }),
            panel_ids: panels.map((test) => test.value),
            order: 0,
            unit: testData.unit,
            note: testData.note,
            input_type: testData.input_type,
            reference_parameter: refRange.filter(
                (range) => range.category && range.min_value && range.max_value
            ),
            parameters: tests.map((test, index) => ({
                test_parameter: test.selectedOption?.value || '',
                input_type: test.value,
                is_required: true,
                unit: test.unit || '',
                order: parseInt(test.order),
                note: test.note || '',
                reference_parameter: (test.reference_parameter || []).filter(
                    (range) => range.category && range.min_value && range.max_value
                ),
                sub_parameters: (test.sub_tests || []).map((sub, subIndex) => ({
                    name: sub.selectedOption?.value || '',
                    value: sub.value,
                    unit: sub.unit || '',
                    order: parseInt(sub.order),
                    note: sub.note || '',
                    // calculation_type: sub.calculation_type || '',
                    ref_range: (sub.reference_parameter || []).filter(
                        (range) => range.category && range.min_value && range.max_value
                    ),
                }))
            }))
        };


        const tokenString = sessionStorage.getItem('usertoken');
        const str = tokenString.replace(/["]+/g, '');
        axios
            .post(`${APIURL}/api/v1/staff/lab-test/?${TZ}`, payload, {
                headers: {
                    Authorization: 'Token ' + str,
                },
            })
            .then((res) => {
                if (res.status === 200 && res.data.status === 'success') {
                    alert.success('Test added successfully!');
                    props.handleSuccess();
                } else {
                    alert.error(res.data.message || 'Failed to add test.');
                }
            })
            .catch((err) => {
                alert.error('Failed to add test. Please try again.');
            });
    };

    return (
        <div>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
                show={true}
            >
                <Modal.Header closeButton onHide={props.onClose}>
                    <Modal.Title><b>Add Test</b></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ display: "flex" }}>
                    {props.type === 'global' &&
                        <div className="left-side-buttons col-3" style={{ padding: 0 }}>
                            <div className="left-side-buttons-title">Samples</div>
                            <div className="left-side-buttons" style={{ borderRadius: 0, border: "none" }}>
                                {sampleList.map((category) => (
                                    <button
                                        key={category}
                                        className={`category-button ${testData.sample === category ? "active" : ""}`}
                                        onClick={() => handleCategoryClick(category)}
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>
                        </div>
                    }
                    <div className={`panel-container ${props.type === 'global' ? 'col-9' : 'col-12'}`}>
                        {props.type === 'global' &&
                            <div className='pricing-inputcontainer'>
                                <span>Required sample</span>
                                <input
                                    style={{ textTransform: "capitalize" }}
                                    value={testData.sample}
                                    disabled
                                />
                            </div>
                        }
                        <div className='pricing-inputcontainer'>
                            <span className='required'>Test Name</span>
                            <input
                                className={`${error.testName ? 'has-error-input' : ''}`}
                                name="name"
                                placeholder='Test Name'
                                value={testData.name}
                                onChange={handleInputChange}
                            />
                            {error.testName && <div className="error-message">{error.testName}</div>}
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Unit</span>
                            <input
                                name="unit"
                                placeholder='Unit'
                                value={testData.unit}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='pricing-inputcontainer' >
                            <span>Value</span>
                            <CustomSelect
                                options={valueOptions}
                                value={valueOptions.find(opt => opt.value === testData.input_type) || null}
                                onChange={(selectedOption) => setTestData(prev => ({
                                    ...prev,
                                    input_type: selectedOption ? selectedOption.value : ''
                                }))}
                                placeholder="Select Value"
                            />
                        </div>
                        {props.type === 'testgroup' &&
                            <div className='pricing-inputcontainer'>
                                <span>Sample</span>
                                <Select
                                    className='input-container'
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            minHeight: '40px',
                                            border: error?.tests ? '1px solid red' : '1px solid #E3E3E3',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            // maxHeight: '200px !important',
                                            zIndex: 100,
                                        }),
                                        menuList: (provided) => ({
                                            ...provided,
                                            maxHeight: '200px !important',
                                            zIndex: 100,
                                        }),
                                    }}
                                    value={sampleType}
                                    onChange={(option) => setSampleType(option)}
                                    options={samples}
                                    placeholder="Select sample"
                                />
                            </div>
                        }
                        <div className='pricing-inputcontainer'>
                            <span>Reference Range</span>
                            {refRange.map((range, index) => (
                                <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                    <div className='col-5' style={{ padding: 0 }}>
                                        <CustomSelect
                                            options={optionsList}
                                            name="category"
                                            placeholder='Category'
                                            value={optionsList.find(option => option.value === range.category) || null}
                                            onChange={(selectedOption) => handleRefChange(index, selectedOption)}
                                        />
                                    </div>
                                    <input className='col-3'
                                        name="min_value"
                                        placeholder='Min Value'
                                        value={range.min_value}
                                        onChange={(e) => handleRefRangeChange(index, e)}
                                    />
                                    <input className='col-3'
                                        name="max_value"
                                        placeholder='Max Value'
                                        value={range.max_value}
                                        onChange={(e) => handleRefRangeChange(index, e)}
                                    />
                                    {index > 0 && (
                                        <button
                                            type="button"

                                            style={{ cursor: 'pointer', background: 'none', border: 'none', borderRadius: '4px' }}
                                            onClick={() => {
                                                const prevRange = refRange[index - 1];
                                                const updatedRefs = [...refRange];
                                                updatedRefs[index] = {
                                                    ...updatedRefs[index],
                                                    // category: prevRange.category,
                                                    min_value: prevRange.min_value,
                                                    max_value: prevRange.max_value
                                                };
                                                setRefRange(updatedRefs);
                                            }}
                                        >
                                            <IoCopyOutline />
                                        </button>
                                    )}
                                    <button
                                        className='remove-btn'
                                        onClick={() => removeRefRange(index)}
                                    >
                                        -
                                    </button>
                                </div>
                            ))}
                            <button className='add-btn' onClick={addRefRange}>
                                Add Reference Range
                            </button>
                        </div>
                        {props.type !== 'global' && (
                            <div className='pricing-inputcontainer'>
                                <span>Parameter</span>
                                {tests.map((testItem, testIndex) => (
                                    <div
                                        key={testIndex}
                                        style={{
                                            position: 'relative',
                                            border: '1px solid #E3E3E3',
                                            padding: '25px 15px 15px 15px',
                                            borderRadius: '8px',
                                            marginBottom: '15px',
                                            backgroundColor: '#fafafa'
                                        }}
                                    >
                                        <TestParameterRow
                                            item={testItem}
                                            parentIndex={testIndex}
                                            tests={tests}
                                            handleTestFieldChange={handleTestFieldChange}
                                            handleNestedRefChange={handleNestedRefChange}
                                            addNestedRefRange={addNestedRefRange}
                                            removeNestedRefRange={removeNestedRefRange}
                                            removeTestRow={removeTestRow}
                                            handleAddSubTest={handleAddSubTest}
                                            specificTestOptions={specificTestOptions}
                                            valueOptions={valueOptions}
                                            optionsList={optionsList}
                                            error={error.tests}
                                        />

                                        {testItem.sub_tests && testItem.sub_tests.length > 0 && (
                                            <div style={{ marginLeft: '30px', marginTop: '10px', borderLeft: '3px solid #ccc', paddingLeft: '15px' }}>
                                                <h6 style={{ fontSize: '14px', color: '#666', fontWeight: '600' }}>Subparameters</h6>
                                                {testItem.sub_tests.map((subItem, subIndex) => (
                                                    <TestParameterRow
                                                        key={subIndex}
                                                        item={subItem}
                                                        parentIndex={testIndex}
                                                        subIndex={subIndex}
                                                        tests={tests}
                                                        handleTestFieldChange={handleTestFieldChange}
                                                        handleNestedRefChange={handleNestedRefChange}
                                                        addNestedRefRange={addNestedRefRange}
                                                        removeNestedRefRange={removeNestedRefRange}
                                                        removeTestRow={removeTestRow}
                                                        specificTestOptions={specificTestOptions}
                                                        valueOptions={valueOptions}
                                                        optionsList={optionsList}
                                                        error={error.tests}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                        <button
                                            type="button"
                                            className='add-btn'
                                            onClick={() => handleAddSubTest(testIndex)}
                                        >
                                            {testItem.sub_tests && testItem.sub_tests.length > 0
                                                ? "+ Add Another Subparameter Test"
                                                : "4. Add New Subparameter Test"
                                            }
                                        </button>
                                    </div>
                                ))}

                                {error.tests && <p style={{ color: 'red', margin: '5px 0 0 0' }}>{error.tests}</p>}

                                <button
                                    type="button"
                                    className='add-btn'
                                    onClick={addTestRow}
                                    style={{ marginTop: '10px' }}
                                >
                                    {tests.length > 0 ? "+ Add Another Parameter" : "Add New Parameter"}
                                </button>
                            </div>
                        )}
                        <div className='pricing-inputcontainer'>
                            <span>Panels</span>
                            <Select
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: '44px',
                                        border: error.tests ? '1px solid red' : '1px solid #E3E3E3',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        // maxHeight: '200px!important',
                                        zIndex: 9999,
                                    }),
                                    menuList: (provided) => ({
                                        ...provided,
                                        maxHeight: '200px!important',
                                        zIndex: 9999,
                                    }),
                                }}
                                isMulti
                                value={panels}
                                onChange={handleTestChange}
                                options={panelsList}
                                placeholder="Select Panels"
                            />
                            {error.panels && <p style={{ color: 'red' }}>{error.panels}</p>}
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Note</span>
                            <input
                                name="note"
                                placeholder='Note'
                                value={testData.note}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div style={{ display: "flex", gap: "10px", margin: "auto 0 0 auto" }}>
                            <button className='add-btn' onClick={props.onClose}>
                                Close
                            </button>
                            <button className='add-btn' onClick={handleSubmit}>
                                Save
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default TestShow;